import React from 'react';

const AssessmentsPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-[#272727]">Assessments & Estimates</h1>
    </div>
  );
};

export default AssessmentsPage;
